import { SlotType } from '@sparelabs/domain-logic'
import { IPoint } from '@sparelabs/geography'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum DutyDelayType {
  UnexpectedStop = 'unexpectedStop',
  DelayedStopCompletion = 'delayedStopCompletion',
  DelayedStopDeparture = 'delayedStopDeparture',
  SlowDriving = 'slowDriving',
}

export enum DutyDelayClosedReason {
  VehicleMoved = 'vehicleMoved',
  ScheduleChanged = 'scheduleChanged',
  SlotCompleted = 'slotCompleted',
  DriverBreakStarted = 'driverBreakStarted',
  DelayResolved = 'delayResolved',
  VehicleIdle = 'vehicleIdle',
}

export interface IDutyDelayResponse extends IModelJsonValues {
  id: string
  type: DutyDelayType
  isActive: boolean
  slotId: string | null
  slotType?: SlotType | null
  requestId: string
  dutyId: string | null
  driverId: string
  createdAt: number
  originalSlotScheduledTs: number
  currentSlotScheduledTs: number
  delayStartLocation: IPoint | null
  delayEndLocation: IPoint | null
  stopLocation: IPoint | null
  closedTs: number | null
  closedReason: DutyDelayClosedReason | null
}

export interface IListDutyDelayQueryParams extends IListModelQueryParamValues {
  fleetId?: string
  dutyId?: string
  driverId?: string
  requestId?: string
  type?: DutyDelayType[]
  closedReason?: DutyDelayClosedReason
  isActive?: boolean
  fromCreatedAtTs?: number
  toCreatedAtTs?: number
  fromClosedTs?: number
  toClosedTs?: number
  minDelayS?: number
}
